import { SelectProps } from "antd";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";
import { TipoFiltroDataRelatorioPrestacaoContas } from "features/relatorios/prestacao-contas/typings";

export interface SelectTipoFiltroDataRelatorioProps<T = any>
  extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  anual?: boolean;
  includeAnual?: boolean;
  includeTodosOsMeses?: boolean;
}

function SelectTipoFiltroDataRelatorio({
  value,
  anual,
  includeAnual = true,
  includeTodosOsMeses = true,
  ...rest
}: SelectTipoFiltroDataRelatorioProps) {
  let options = includeAnual
    ? [
        {
          value: TipoFiltroDataRelatorioPrestacaoContas.AnoAnterior,
          label: "Ano anterior",
        },
        {
          value: TipoFiltroDataRelatorioPrestacaoContas.AnoAtual,
          label: "Ano atual",
        },
        {
          value: TipoFiltroDataRelatorioPrestacaoContas.ProximoAno,
          label: "Próximo ano",
        },
      ]
    : [];

  if (!anual) {
    options = options.concat([
      {
        value: TipoFiltroDataRelatorioPrestacaoContas.DoisMesesAtras,
        label: "Dois meses atrás",
      },
      {
        value: TipoFiltroDataRelatorioPrestacaoContas.MesAnterior,
        label: "Mês anterior",
      },
      {
        value: TipoFiltroDataRelatorioPrestacaoContas.MesAtual,
        label: "Mês atual",
      },
    ]);
  }

  if (includeTodosOsMeses) {
    options = options.concat({
      value: TipoFiltroDataRelatorioPrestacaoContas.TodosOsMeses,
      label: "Todos os meses",
    });
  }

  options = options.concat({
    value: TipoFiltroDataRelatorioPrestacaoContas.MesEspecifico,
    label: "Mês específico",
  });

  return (
    <SelectBaseAntd
      size="large"
      getPopupContainer={(node) => node.parentNode}
      placeholder="Selecione"
      value={value}
      options={options}
      {...rest}
    />
  );
}

export default SelectTipoFiltroDataRelatorio;
